import { SelectFieldOption } from "../types";

export const getCountriesForSelect = (
  countries: Array<string>
): SelectFieldOption[] =>
  (countries || []).map(([text, key]: [string, string]) => {
    return { key, text };
  });
